import React, { Component } from 'react';
import { Grid, Row, Col, FormGroup, Radio, Button, ButtonToolbar } from 'react-bootstrap'

export class LineInformationDataIdentifier extends Component {
    onSelectData(data) {
        this.props.onSelectData(data);
    }

    render() {
        const { selectedData } = this.props;

        return (
            <div>
                <Grid fluid>
                    <Row>
                        <Col sm={12}>
                            <b>Dados a aprensentar como identificador da linha</b>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12}>
                            <FormGroup>
                                <Radio
                                    name="lineInfo"
                                    checked={"linename" === selectedData}
                                    onChange={() => this.props.onSelectData("linename")} >
                                    Nome da Linha
                                </Radio>
                                <Radio
                                    name="lineInfo"
                                    checked={"stopsname" === selectedData}
                                    onChange={() => this.props.onSelectData("stopsname")} >
                                    Nome da 1ª e Última paragens
                                </Radio>
                            </FormGroup>
                        </Col>
                    </Row>
                </Grid>

                <ButtonToolbar>
                    <Button bsStyle="default" onClick={() => this.props.onCancel()}>FECHAR</Button>
                </ButtonToolbar>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/layoutConfigurations/dataIdentifiers/LineInformationDataIdentifier.js